import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2.5, 3),
    height: '100%',
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,
  },
  label: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: 36,
    fontWeight: 700,
    color: theme.palette.phishing.statCardValue,
    lineHeight: 1.1,
    marginBottom: theme.spacing(0.75),
  },
  subLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
